import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "roles-tab" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = { class: "tab-sub" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = {
  key: 1,
  class: "roles-list"
}
const _hoisted_7 = { class: "role-card-left" }
const _hoisted_8 = { class: "role-name-row" }
const _hoisted_9 = { class: "role-name" }
const _hoisted_10 = {
  key: 0,
  class: "badge badge--analyst"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge--admin"
}
const _hoisted_12 = { class: "role-perms" }
const _hoisted_13 = {
  key: 0,
  class: "perm-chip perm-chip--green"
}
const _hoisted_14 = {
  key: 1,
  class: "perm-chip perm-chip--orange"
}
const _hoisted_15 = {
  key: 2,
  class: "perm-chip perm-chip--blue"
}
const _hoisted_16 = {
  key: 0,
  class: "perm-chip perm-chip--neutral"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "role-form"
}
const _hoisted_19 = { class: "form-title" }
const _hoisted_20 = { class: "analyst-toggle" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = {
  key: 0,
  class: "analyst-note"
}
const _hoisted_23 = { class: "field" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "toggle-row" }
const _hoisted_27 = ["checked", "disabled"]
const _hoisted_28 = { class: "field field--no-top" }
const _hoisted_29 = { class: "warehouse-options" }
const _hoisted_30 = ["value", "checked", "disabled", "onChange"]
const _hoisted_31 = { class: "radio-label" }
const _hoisted_32 = { class: "toggle-row" }
const _hoisted_33 = ["checked", "disabled"]
const _hoisted_34 = { class: "toggle-row" }
const _hoisted_35 = ["checked", "disabled"]
const _hoisted_36 = { class: "field field--no-top" }
const _hoisted_37 = { class: "warehouse-options" }
const _hoisted_38 = ["value", "checked", "disabled", "onChange"]
const _hoisted_39 = { class: "radio-label" }
const _hoisted_40 = { class: "field field--no-top" }
const _hoisted_41 = { class: "subordinate-tags" }
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 1,
  class: "no-subs"
}
const _hoisted_46 = {
  key: 0,
  class: "form-error"
}
const _hoisted_47 = { class: "form-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "tab-title" }, "Cargos", -1)),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.roles.length) + " cargo" + _toDisplayString(_ctx.roles.length !== 1 ? 's' : '') + " cadastrado" + _toDisplayString(_ctx.roles.length !== 1 ? 's' : ''), 1)
      ]),
      (!_ctx.isAnalyst && !_ctx.showRoleForm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-new",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-role-form')))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
              }),
              _createElementVNode("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
              })
            ], -1),
            _createTextVNode(" Novo cargo ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showRoleForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.roles.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("svg", {
                  width: "36",
                  height: "36",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  opacity: "0.3"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "8",
                    r: "4"
                  }),
                  _createElementVNode("path", { d: "M4 20c0-4 3.6-7 8-7s8 3 8 7" })
                ], -1),
                _createElementVNode("p", null, [
                  _createTextVNode("Nenhum cargo cadastrado."),
                  _createElementVNode("br"),
                  _createTextVNode("Crie o primeiro cargo para organizar sua equipe.")
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: role.id,
                    class: "role-card"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(role.name), 1),
                        (role.isAnalyst)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Analista"))
                          : (role.isAdmin)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Admin"))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["perm-chip", _ctx.warehouseChipClass(role.warehouseAccess)])
                        }, _toDisplayString(_ctx.warehouseShortLabel(role.warehouseAccess)), 3),
                        (!role.isAnalyst && !role.isAdmin)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (role.constructionAccess)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Construção"))
                                : _createCommentVNode("", true),
                              (role.maintenanceAccess)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Manutenção"))
                                : _createCommentVNode("", true),
                              (role.portariaAccess)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Portaria"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (!role.isAnalyst)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.roleSubordinateNames(role).length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.roleSubordinateNames(role).length) + " subordinado" + _toDisplayString(_ctx.roleSubordinateNames(role).length > 1 ? 's' : ''), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (!_ctx.isAnalyst)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn-edit",
                          type: "button",
                          onClick: ($event: any) => (_ctx.$emit('edit-role', role))
                        }, "Editar", 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRoleForm && !_ctx.isAnalyst)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.roleForm.isEditing ? 'Editar cargo' : 'Novo cargo'), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["analyst-block", { 'analyst-block--active': _ctx.roleForm.isAnalyst }])
          }, [
            _createElementVNode("label", _hoisted_20, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.roleForm.isAnalyst,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateField('isAnalyst', ($event.target as HTMLInputElement).checked)))
              }, null, 40, _hoisted_21),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "analyst-text" }, [
                _createElementVNode("strong", null, "Perfil de analista"),
                _createElementVNode("span", null, "Acesso completo de leitura — visualiza tudo como admin, mas não cria, edita ou exclui nada.")
              ], -1))
            ]),
            (_ctx.roleForm.isAnalyst)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Quando ativo, todas as outras permissões são ignoradas. "))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_23, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "field-label",
              for: "role-name"
            }, "Nome do cargo", -1)),
            _createElementVNode("input", {
              id: "role-name",
              class: "field-input",
              type: "text",
              placeholder: "Ex: Encarregado, Pedreiro...",
              value: _ctx.roleForm.name,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateField('name', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_24)
          ]),
          _createElementVNode("fieldset", {
            class: _normalizeClass(["perms-block", { frozen: _ctx.roleForm.isAnalyst }]),
            disabled: _ctx.roleForm.isAnalyst
          }, [
            _cache[22] || (_cache[22] = _createElementVNode("legend", { class: "perms-legend" }, "Permissões", -1)),
            _createElementVNode("label", _hoisted_26, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.roleForm.isAdmin,
                disabled: _ctx.roleForm.isAnalyst,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateField('isAdmin', ($event.target as HTMLInputElement).checked)))
              }, null, 40, _hoisted_27),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "toggle-text" }, [
                _createElementVNode("strong", null, "Administrador da obra"),
                _createElementVNode("span", null, "Pode gerenciar projetos, usuários e configurações.")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "field-label" }, "Acesso ao almoxarifado", -1)),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseOptions, (opt) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: opt.value,
                    class: _normalizeClass(["radio-option", { selected: _ctx.roleForm.warehouseAccess === opt.value }])
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      value: opt.value,
                      checked: _ctx.roleForm.warehouseAccess === opt.value,
                      disabled: _ctx.roleForm.isAnalyst,
                      onChange: ($event: any) => (_ctx.updateField('warehouseAccess', opt.value))
                    }, null, 40, _hoisted_30),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(opt.label), 1)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("label", _hoisted_32, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: Boolean(_ctx.roleForm.constructionAccess),
                disabled: _ctx.roleForm.isAnalyst,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateField('constructionAccess', ($event.target as HTMLInputElement).checked ? 1 : 0)))
              }, null, 40, _hoisted_33),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "toggle-text" }, [
                _createElementVNode("strong", null, "Acesso ao Modo Construção"),
                _createElementVNode("span", null, "Pode acessar projetos, relatórios e o planejamento da obra.")
              ], -1))
            ]),
            _createElementVNode("label", _hoisted_34, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: Boolean(_ctx.roleForm.maintenanceAccess),
                disabled: _ctx.roleForm.isAnalyst,
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateField('maintenanceAccess', ($event.target as HTMLInputElement).checked ? 1 : 0)))
              }, null, 40, _hoisted_35),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "toggle-text" }, [
                _createElementVNode("strong", null, "Acesso ao Modo Manutenção"),
                _createElementVNode("span", null, "Pode acessar rotinas e tarefas de manutenção (requer que o módulo esteja ativado no sistema).")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "field-label" }, "Acesso à Portaria", -1)),
              _createElementVNode("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portariaOptions, (opt) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: opt.value,
                    class: _normalizeClass(["radio-option", { selected: _ctx.roleForm.portariaAccess === opt.value }])
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      value: opt.value,
                      checked: _ctx.roleForm.portariaAccess === opt.value,
                      disabled: _ctx.roleForm.isAnalyst,
                      onChange: ($event: any) => (_ctx.updateField('portariaAccess', opt.value))
                    }, null, 40, _hoisted_38),
                    _createElementVNode("span", _hoisted_39, _toDisplayString(opt.label), 1)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "field-label" }, "Cargos subordinados", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("p", { class: "field-hint" }, "Usuários com este cargo podem visualizar/gerenciar usuários dos cargos abaixo.", -1)),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledSubordinates, (roleId, idx) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: roleId,
                    class: "sub-tag"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.roleName(roleId)) + " ", 1),
                    _createElementVNode("button", {
                      class: "sub-tag-remove",
                      type: "button",
                      disabled: _ctx.roleForm.isAnalyst,
                      onClick: ($event: any) => (_ctx.removeSubordinate(idx))
                    }, "×", 8, _hoisted_42)
                  ]))
                }), 128)),
                (_ctx.availableSubordinates.length)
                  ? (_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "sub-add-select",
                      disabled: _ctx.roleForm.isAnalyst,
                      value: "",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => {_ctx.addSubordinate(($event.target as HTMLSelectElement).value); ($event.target as HTMLSelectElement).value = ''})
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "+ Adicionar subordinado", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableSubordinates, (r) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: r.id,
                          value: r.id
                        }, _toDisplayString(r.name), 9, _hoisted_44))
                      }), 128))
                    ], 40, _hoisted_43))
                  : (_ctx.filledSubordinates.length === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Nenhum subordinado definido"))
                    : _createCommentVNode("", true)
              ])
            ])
          ], 10, _hoisted_25),
          (_ctx.roleError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.roleError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('save-role')))
            }, _toDisplayString(_ctx.roleForm.isEditing ? 'Salvar alterações' : 'Criar cargo'), 1),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close-role-form')))
            }, "Cancelar")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}